import DateRangePicker from './DateRangePicker';
import * as constants from './constants';

const log = require('debug')('@mycure/vue-plugins/' + constants.NAMESPACE);

/**
 * @typedef {Object} PluginOpts
 * @property {boolean} injectComponents
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {PluginOpts} [opts]
   */
  install (Vue, opts) {
    opts = Object.assign({ injectComponents: true }, opts);
    log(`installing '${constants.NAMESPACE}' with opts'`, opts);

    // inject components
    if (opts.injectComponents) Vue.component('mc-date-range-picker', DateRangePicker);
  },
  namespace: constants.NAMESPACE
};
